import * as React from 'react';
export const IcFantasy = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.36 13.29C1.75 14.89 2 19.18 2 20a1 1 0 00.92.92c.24 0 .75.05 1.38.05 1.65 0 4.21-.21 5.37-1.37A4.47 4.47 0 0011 17.07L5.92 12a4.45 4.45 0 00-2.56 1.29zM6 7a1 1 0 100-2 1 1 0 000 2zm7-2a1 1 0 100-2 1 1 0 000 2zm4.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM20 3.78a1 1 0 00-.779-.779 1 1 0 00-1.031.419l-1.86 2.8-3.75 1.87a.9.9 0 00-.38.34l-1.28 1.91-.18-.19a.83.83 0 00-.33-.22 1 1 0 00-.41-.08 1.09 1.09 0 00-.39.08.87.87 0 00-.32.22l-.51.52-1.21-1.23a1 1 0 00-.69-.24 1 1 0 00-.66.29 1 1 0 00-.3.67 1 1 0 00.24.68l6 6a1 1 0 001.41 0 1 1 0 000-1.41l-1.23-1.23.52-.51c.09-.098.164-.21.22-.33a1.07 1.07 0 000-.76 1.119 1.119 0 00-.22-.33l-.5-.49 1.35-2 3.76-1.88a1 1 0 00.38-.4l2-3a1 1 0 00.15-.72z'
      fill='currentColor'
    />
  </svg>
);
